import { InfiniteList } from '@src/design-system/molecules/infinite-list';
import { FilterOptionItem } from '@src/design-system/filter-new';

import type { TEntityFilterConfig } from '../../../types/filter-config';
import { useTableViewHelpers } from '@design-system/molecules/ticlick-table/hooks/use-table-view-helpers';
import {
  FILTER_NONE_LABEL,
  FILTER_NONE_VALUE,
} from '../../../helpers/filter-none';
import { useShowsNoneOption } from '../../../helpers/use-shows-none-option';

export function EntityFilterPanel<T extends Record<string, unknown>>({
  config,
}: {
  config: TEntityFilterConfig<T>;
}) {
  const { setFacetValue, getSelectedStaticFilterFacet } = useTableViewHelpers();
  const showNoneOption = useShowsNoneOption(config.withNoneOption);

  const facet = getSelectedStaticFilterFacet(config.facetName);
  const selectedValues = facet?.value || [];
  const valuesWithoutNone = selectedValues.filter(
    (value) => value !== FILTER_NONE_VALUE
  );

  return (
    <div>
      <InfiniteList
        {...config}
        enableSearch
        props={{
          listProps: { className: 'gap-0' },
          listContainerProps: { className: 'max-h-[200px]' },
          searchInputProps: { size: 'xs' },
        }}
        renderItem={(item) => {
          const val = config.getValue(item);
          const isSelected = valuesWithoutNone.includes(val);

          return config.renderItem({
            item,
            selected: isSelected,
            onToggle: () => {
              const noneSelected = selectedValues.includes(FILTER_NONE_VALUE);
              const nextIds = isSelected
                ? valuesWithoutNone.filter((v) => v !== val)
                : [...valuesWithoutNone, val];

              setFacetValue({
                field: config.facetName,
                entityType: config.entityType,
                value: noneSelected ? [...nextIds, FILTER_NONE_VALUE] : nextIds,
              });
            },
          });
        }}
      />
      {showNoneOption ? (
        <div className='border-t border-pale-border px-3 pb-3'>
          <FilterOptionItem
            onClick={() => {
              const isSelected = selectedValues.includes(FILTER_NONE_VALUE);
              setFacetValue({
                field: config.facetName,
                entityType: config.entityType,
                value: isSelected
                  ? valuesWithoutNone
                  : [...valuesWithoutNone, FILTER_NONE_VALUE],
              });
            }}
            selected={selectedValues.includes(FILTER_NONE_VALUE)}
          >
            {FILTER_NONE_LABEL}
          </FilterOptionItem>
        </div>
      ) : null}
    </div>
  );
}
